import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';

function MarketingChannel() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable certain keyboard shortcuts
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Disable text selection and copy
    const handleCopy = (e) => {
      e.preventDefault();
      return false;
    };

    // Disable drag
    const handleDragStart = (e) => {
      e.preventDefault();
      return false;
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);

    // Disable text selection via CSS
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      {/* Navbar */}
      <Navbar />

      {/* Protection styles for images */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        html, body {
          overflow-x: hidden;
          max-width: 100%;
        }
      `}</style>

      {/* Background stars effect */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* Hero Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-16 sm:py-24 overflow-hidden min-h-[50vh] flex items-center">
        {/* Background Image using img tag */}
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="/Assests/home_page.png" 
            alt="Marketing Channels Background" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="max-w-7xl mx-auto relative z-10 w-full">

          {/* Main Heading */}
          <h1 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight max-w-6xl">
            Marketing Channels & Tactics Guide
          </h1>

          {/* Description */}
          <p className="text-gray-300 text-lg lg:text-xl leading-relaxed max-w-4xl mb-12">
            Navigate the evolving landscape of marketing channels and discover which tactics will drive your business forward in today's competitive marketplace.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-3 sm:gap-4">
            <button className="px-6 sm:px-8 py-3 bg-orange-500 text-white rounded-md font-medium hover:bg-orange-600 transition">
              Explore Channels
            </button>
            <button className="px-8 py-3 border border-orange-500 text-orange-500 rounded-md font-medium hover:bg-orange-500 hover:text-white transition">
              Download Guide
            </button>
          </div>

        </div>
      </section>

        {/* Understanding Marketing Channels Section */}
        <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20">
        <div className="max-w-7xl mx-auto">
            
            <div className="grid lg:grid-cols-2 gap-6 sm:gap-12">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
                
                {/* Main Heading */}
                <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
                Understanding Marketing Channels
                </h2>

                {/* First Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                In today's fragmented media landscape, choosing the right marketing channels can make or break your business growth. Marketing channels are the pathways through which you communicate with your target audience, deliver value, and ultimately drive conversions.
                </p>

                {/* Second Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                The key to successful marketing isn't just selecting channels—it's understanding how each channel serves different purposes in your customer journey. Some channels excel at awareness, others at engagement, and still others at conversion. Your optimal mix depends on your specific business goals, target audience preferences, and available resources.
                </p>

                {/* Third Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                This guide breaks down the most effective marketing channels available today, helping you make informed decisions about where to invest your time, energy, and budget for maximum return.
                </p>

            </div>

            {/* Right Side - Key Considerations */}
            <div className="space-y-6 mt-8 lg:mt-32">
                
                {/* Key Considerations Heading */}
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6">
                Key Considerations
                </h3>

                {/* List Items */}
                <div className="space-y-4">
                
                <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-300 text-lg">Target audience behavior</p>
                </div>

                <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-300 text-lg">Budget constraints</p>
                </div>

                <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-300 text-lg">Content capabilities</p>
                </div>

                <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-300 text-lg">Measurement tools</p>
                </div>

                <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-300 text-lg">Competitive landscape</p>
                </div>

                <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-300 text-lg">Integration potential</p>
                </div>

                </div>

            </div>

            </div>

        </div>
        </section>

        {/* Content Marketing: The Foundation Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/70">
        <div className="max-w-7xl mx-auto">
          
          {/* Content Card with dark background */}
          <div className="bg-gradient-to-br from-gray-900/30 to-black rounded-3xl p-5 sm:p-8 lg:p-12 border border-orange-600">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
              Content Marketing: The Foundation
            </h2>

            {/* First Paragraph */}
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              Content marketing is the strategic creation and distribution of valuable, relevant content to attract and retain a clearly defined audience. Through blogs, articles, videos, and infographics, you educate prospects while establishing your brand as a trusted authority in your industry.
            </p>

            {/* Second Paragraph */}
            <p className="text-gray-300 text-lg leading-relaxed mb-12">
              This channel works because it addresses the fundamental shift in how buyers make decisions. Today's consumers research extensively before purchasing, seeking educational content that helps them solve problems. By providing this content, you intercept them early in their journey and build trust that converts later.
            </p>

            {/* Four Cards Grid */}
            <div className="grid md:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
              
              {/* Card 1 - Blog Articles */}
              <div className="bg-black rounded-2xl p-6 border border-orange-600/30 hover:border-orange-500 transition">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">Blog Articles</h3>
                <p className="text-gray-400 text-base">Long-form written content optimized for search engines and reader value</p>
              </div>

              {/* Card 2 - Video Content */}
              <div className="bg-black rounded-2xl p-6 border border-orange-600/30 hover:border-orange-500 transition">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">Video Content</h3>
                <p className="text-gray-400 text-base">Engaging visual storytelling that simplifies complex topics</p>
              </div>

              {/* Card 3 - Infographics */}
              <div className="bg-black rounded-2xl p-6 border border-orange-600/30 hover:border-orange-500 transition">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">Infographics</h3>
                <p className="text-gray-400 text-base">Data visualization that makes statistics shareable and memorable</p>
              </div>

              {/* Card 4 - Guides & Ebooks */}
              <div className="bg-black rounded-2xl p-6 border border-orange-600/30 hover:border-orange-500 transition">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white mb-3">Guides & Ebooks</h3>
                <p className="text-gray-400 text-base">Comprehensive resources that demonstrate deep expertise</p>
              </div>

            </div>

            {/* Bottom Paragraph */}
            <p className="text-gray-300 text-lg leading-relaxed">
              The beauty of content marketing lies in its compounding returns. Unlike paid advertising that stops the moment you stop spending, quality content continues attracting visitors months or even years after publication. <span className="text-orange-500 font-semibold">Each piece becomes a permanent asset</span> that works for your business around the clock.
            </p>

          </div>

        </div>
      </section>

      {/* Social Media Marketing: Building Community Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12 text-center">
            Social Media Marketing: Building Community
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 mb-8 sm:mb-12">
            
            {/* Left Side - Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_54.png" 
                  alt="Social Media Marketing" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-6 flex flex-col justify-center">
              
              {/* Subheading */}
              <h3 className="text-3xl font-bold text-white">
                Where Your Audience Lives
              </h3>

              {/* First Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Social media marketing leverages platforms like Instagram, Facebook, LinkedIn, and TikTok to connect with audiences where they spend their time. Each platform offers unique opportunities to build community, foster engagement, and humanize your brand.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                The platform you choose matters enormously. B2B companies often find their best ROI on LinkedIn, while consumer brands might thrive on Instagram or TikTok. Understanding platform demographics and content formats is crucial for success.
              </p>

            </div>

          </div>

          {/* Four Platform Cards Grid */}
          <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
            
            {/* Card 1 - Instagram */}
            <div className="relative bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition">
              {/* Icon Circle */}
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="pt-8">
                <h3 className="text-2xl font-bold text-white mb-3">Instagram</h3>
                <p className="text-gray-400 text-base leading-relaxed">
                  Visual storytelling through photos, Stories, and Reels. Ideal for lifestyle brands, fashion, food, and visual products targeting younger demographics.
                </p>
              </div>
            </div>

            {/* Card 2 - Facebook */}
            <div className="relative bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition">
              {/* Icon Circle */}
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <div className="pt-8">
                <h3 className="text-2xl font-bold text-white mb-3">Facebook</h3>
                <p className="text-gray-400 text-base leading-relaxed">
                  Broad demographic reach with sophisticated ad targeting. Strong for community building through Groups and effective for local businesses.
                </p>
              </div>
            </div>

            {/* Card 3 - LinkedIn */}
            <div className="relative bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition mt-6">
              {/* Icon Circle */}
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="pt-8">
                <h3 className="text-2xl font-bold text-white mb-3">LinkedIn</h3>
                <p className="text-gray-400 text-base leading-relaxed">
                  Professional network perfect for B2B marketing, thought leadership, recruitment, and connecting with decision-makers in target industries.
                </p>
              </div>
            </div>

            {/* Card 4 - TikTok */}
            <div className="relative bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition mt-6">
              {/* Icon Circle */}
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="pt-8">
                <h3 className="text-2xl font-bold text-white mb-3">TikTok</h3>
                <p className="text-gray-400 text-base leading-relaxed">
                  Short-form video platform with explosive reach potential. Authentic, creative content resonates with Gen Z and increasingly millennial audiences.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Search Engine Marketing: Instant Visibility Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-orange-500 mb-6 sm:mb-8">
            Search Engine Marketing: Instant Visibility
          </h2>

          {/* First Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-6">
            Search Engine Marketing (SEM) uses paid advertisements on search engines like Google to capture high-intent traffic. When someone searches for exactly what you offer, your ad appears at the top of results—positioning you perfectly to capture that demand.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-12">
            Unlike many marketing channels that interrupt, SEM responds to existing intent. Users are actively searching for solutions, making them far more likely to convert. This makes SEM particularly effective for businesses with clear value propositions and competitive offerings.
          </p>

          {/* Five Components Grid */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8 mb-8 sm:mb-12">
            
            {/* Component 1 - Keyword Research */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-gray-500 font-mono text-sm">01</span>
                <div className="flex-1 h-px bg-orange-500"></div>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Keyword Research</h3>
              <p className="text-gray-400 text-base leading-relaxed">
                Identify search terms your target customers use when looking for your products or services
              </p>
            </div>

            {/* Component 2 - Ad Creation */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-gray-500 font-mono text-sm">02</span>
                <div className="flex-1 h-px bg-orange-500"></div>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Ad Creation</h3>
              <p className="text-gray-400 text-base leading-relaxed">
                Write compelling ad copy with clear value propositions and strong calls-to-action
              </p>
            </div>

            {/* Component 3 - Bid Management */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-gray-500 font-mono text-sm">03</span>
                <div className="flex-1 h-px bg-orange-500"></div>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Bid Management</h3>
              <p className="text-gray-400 text-base leading-relaxed">
                Set budgets and bids for keywords based on their value and competition level
              </p>
            </div>

          </div>

          {/* Bottom Two Components */}
          <div className="grid md:grid-cols-2 gap-5 sm:gap-8 mb-8 sm:mb-12">
            
            {/* Component 4 - Landing Page Optimization */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-gray-500 font-mono text-sm">04</span>
                <div className="flex-1 h-px bg-orange-500"></div>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Landing Page Optimization</h3>
              <p className="text-gray-400 text-base leading-relaxed">
                Create dedicated pages that match ad messaging and drive conversions
              </p>
            </div>

            {/* Component 5 - Performance Tracking */}
            <div className="space-y-4">
              <div className="flex items-center gap-3 mb-4">
                <span className="text-gray-500 font-mono text-sm">05</span>
                <div className="flex-1 h-px bg-orange-500"></div>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">Performance Tracking</h3>
              <p className="text-gray-400 text-base leading-relaxed">
                Monitor metrics like click-through rate, conversion rate, and cost per acquisition
              </p>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed">
            The key advantage of SEM is control and measurability. You can start campaigns immediately, test different approaches quickly, and scale what works. <span className="text-orange-500 font-semibold">Every dollar spent is trackable to specific results,</span> making ROI crystal clear.
          </p>

        </div>
      </section>

      {/* SEO: The Long-Game Champion Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            SEO: The Long-Game Champion
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 mb-8 sm:mb-12">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* Subheading */}
              <h3 className="text-3xl font-bold text-white">
                Organic Search Power
              </h3>

              {/* First Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Search Engine Optimization (SEO) focuses on earning organic rankings on search engines rather than paying for placement. While SEM delivers immediate results, SEO builds sustainable, long-term traffic that doesn't require continuous ad spend.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                The challenge with SEO is patience—results typically take 3-6 months to materialize. However, once established, organic rankings provide consistent traffic at effectively zero marginal cost per visitor.
              </p>

            </div>

            {/* Right Side - Analytics Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                src="/Assests/home_page_55.png" 
                alt="SEO Analytics Dashboard" 
                className="w-full h-64 object-cover rounded-3xl"
                />
              </div>
            </div>

          </div>

          {/* Three SEO Types - Arrow Design */}
          <div className="grid md:grid-cols-3 gap-0">
            
            {/* Technical SEO */}
            <div className="relative bg-black border-2 border-orange-500 p-8 clip-path-arrow">
              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>
              
              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                Technical SEO
              </h3>
              
              {/* Description */}
              <p className="text-gray-400 text-base leading-relaxed text-center">
                Site speed, mobile optimization, structured data, and crawlability fundamentals
              </p>
            </div>

            {/* On-Page SEO */}
            <div className="relative bg-black border-2 border-orange-500 p-8 clip-path-arrow md:ml-[-2px]">
              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
              </div>
              
              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                On-Page SEO
              </h3>
              
              {/* Description */}
              <p className="text-gray-400 text-base leading-relaxed text-center">
                Keyword optimization, content quality, meta tags, and internal linking structure
              </p>
            </div>

            {/* Off-Page SEO */}
            <div className="relative bg-black border-2 border-orange-500 p-8 clip-path-arrow md:ml-[-2px]">
              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div className="w-12 h-12 flex items-center justify-center">
                  <svg className="w-8 h-8 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                  </svg>
                </div>
              </div>
              
              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4 text-center">
                Off-Page SEO
              </h3>
              
              {/* Description */}
              <p className="text-gray-400 text-base leading-relaxed text-center">
                Backlink building, domain authority, and external signals of trustworthiness
              </p>
              
            </div>

          </div>

          <p className="text-gray-400 text-base leading-relaxed text-center mt-6">
                SEO and content marketing work synergistically. Your content marketing efforts create the pages that rank organically, while SEO ensures those pages are discovered. Together, they form a powerful engine for sustainable growth that builds equity in your digital presence over time.
          </p>

        </div>
      </section>

      {/* Email Marketing: Direct Connection Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-5 sm:mb-6">
            Email Marketing: Direct Connection
          </h2>

          {/* Subheading */}
          <h3 className="text-3xl font-bold text-white mb-8">
            Your Owned Audience
          </h3>

          {/* First Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-6">
            Email marketing remains one of the highest-ROI channels available, delivering an average return of $42 for every dollar spent. Through newsletters, promotions, and personalized messages, you communicate directly with people who've given permission to contact them.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-12">
            Unlike social media where algorithms control visibility, email puts you directly in your audience's inbox. You own the list, control the message, and can segment audiences for highly targeted campaigns. This makes email uniquely powerful for nurturing relationships and driving conversions.
          </p>

          {/* Four Strategy Cards Grid */}
          <div className="grid md:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
            
            {/* Card 1 - List Building */}
            <div className="bg-black rounded-2xl border-2 border-orange-500 overflow-hidden">
              {/* Number Header */}
              <div className="bg-black border-b-2 border-orange-500 px-6 py-4 text-center">
                <span className="text-4xl font-bold text-white">1</span>
              </div>
              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-4">List Building</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Create compelling opt-in offers that provide immediate value in exchange for email addresses. Think lead magnets, exclusive content, or special discounts.
                </p>
              </div>
            </div>

            {/* Card 2 - Segmentation */}
            <div className="bg-black rounded-2xl border-2 border-orange-500 overflow-hidden">
              {/* Number Header */}
              <div className="bg-black border-b-2 border-orange-500 px-6 py-4 text-center">
                <span className="text-4xl font-bold text-white">2</span>
              </div>
              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-4">Segmentation</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Divide your list based on behavior, preferences, or demographics. Targeted messages dramatically outperform generic broadcasts.
                </p>
              </div>
            </div>

            {/* Card 3 - Automation */}
            <div className="bg-black rounded-2xl border-2 border-orange-500 overflow-hidden">
              {/* Number Header */}
              <div className="bg-black border-b-2 border-orange-500 px-6 py-4 text-center">
                <span className="text-4xl font-bold text-white">3</span>
              </div>
              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-4">Automation</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Set up triggered sequences for welcome series, abandoned carts, post-purchase follow-ups, and re-engagement campaigns that work automatically.
                </p>
              </div>
            </div>

            {/* Card 4 - Testing & Optimization */}
            <div className="bg-black rounded-2xl border-2 border-orange-500 overflow-hidden">
              {/* Number Header */}
              <div className="bg-black border-b-2 border-orange-500 px-6 py-4 text-center">
                <span className="text-4xl font-bold text-white">4</span>
              </div>
              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-4">Testing & Optimization</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Continuously improve performance through A/B testing of subject lines, send times, content formats, and calls-to-action.
                </p>
              </div>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed">
            Modern email marketing goes far beyond simple newsletters. Advanced personalization, behavioral triggers, and sophisticated automation turn email into a powerful revenue driver. <span className="bg-orange-500 text-black px-2 py-1 font-semibold">The businesses winning with email treat it as a strategic channel,</span> not just a promotional tool.
          </p>

        </div>
      </section>

      {/* Influencer Marketing: Borrowed Authority Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            Influencer Marketing: Borrowed Authority
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 mb-8 sm:mb-12">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* First Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Influencer marketing leverages individuals with established audiences to promote your products or services. Rather than building an audience from scratch, you tap into existing communities through trusted voices who've already earned attention and credibility.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                The power of influencer marketing lies in authenticity and trust. When a respected influencer recommends your product, their endorsement carries weight that traditional advertising simply cannot match. Their audience sees them as a peer or aspirational figure, not a brand trying to sell something.
              </p>

              {/* Third Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Successful influencer campaigns require careful matching between your brand, the influencer's audience, and the influencer's personal brand. Authenticity is paramount—audiences quickly detect inauthentic partnerships and react negatively.
              </p>

            </div>

            {/* Right Side - Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_56.png" 
                  alt="Influencer Marketing" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
            </div>

          </div>

          {/* Four Influencer Types Grid */}
          <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
            
            {/* Nano-Influencers */}
            <div className="bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition">
              <h3 className="text-2xl font-bold text-white mb-3">Nano-Influencers</h3>
              <p className="text-orange-400 text-lg font-semibold mb-4">1K-10K followers</p>
              <p className="text-gray-300 text-base leading-relaxed">
                Highest engagement rates, authentic connections, affordable partnerships
              </p>
            </div>

            {/* Micro-Influencers */}
            <div className="bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition">
              <h3 className="text-2xl font-bold text-white mb-3">Micro-Influencers</h3>
              <p className="text-orange-400 text-lg font-semibold mb-4">10K-100K followers</p>
              <p className="text-gray-300 text-base leading-relaxed">
                Strong niche authority, good engagement, reasonable costs
              </p>
            </div>

            {/* Macro-Influencers */}
            <div className="bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition">
              <h3 className="text-2xl font-bold text-white mb-3">Macro-Influencers</h3>
              <p className="text-orange-400 text-lg font-semibold mb-4">100K-1M followers</p>
              <p className="text-gray-300 text-base leading-relaxed">
                Significant reach, professional content, higher investment required
              </p>
            </div>

            {/* Mega-Influencers */}
            <div className="bg-black rounded-2xl p-6 border-2 border-orange-500 hover:border-orange-400 transition">
              <h3 className="text-2xl font-bold text-white mb-3">Mega-Influencers</h3>
              <p className="text-orange-400 text-lg font-semibold mb-4">1M+ followers</p>
              <p className="text-gray-300 text-base leading-relaxed">
                Maximum visibility, celebrity status, premium pricing
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* Affiliate Marketing: Performance-Based Growth Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            Affiliate Marketing: Performance-Based Growth
          </h2>

          {/* First Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-6">
            Affiliate marketing is a commission-based promotion model where partners earn a percentage of sales they generate. This creates a powerful network of motivated promoters who only get paid when they deliver results—making it one of the most cost-effective customer acquisition channels available.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-16">
            For businesses, affiliate marketing offers risk-free growth. You only pay for actual conversions, not clicks or impressions. This makes it particularly attractive for companies with limited marketing budgets or those testing new markets. Affiliates handle the promotion, while you focus on product delivery and customer service.
          </p>

          {/* Affiliate Components - Responsive Card Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10 sm:mb-16">

            {[
              {
                icon: <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />,
                title: 'Partner Recruitment',
                desc: 'Find affiliates whose audience aligns with your target market'
              },
              {
                icon: <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />,
                title: 'Commission Payment',
                desc: 'Affiliates earn their share, incentivizing continued promotion'
              },
              {
                icon: <path d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />,
                title: 'Commission Structure',
                desc: 'Set competitive rates that motivate promotion while maintaining profitability'
              },
              {
                icon: <path d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />,
                title: 'Content Creation',
                desc: 'Affiliates promote your products through their channels and content'
              },
              {
                icon: <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />,
                title: 'Sales Generation',
                desc: 'Tracked links ensure proper attribution of customer conversions'
              },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-4 bg-gray-900 border border-orange-500/40 rounded-2xl p-5 hover:border-orange-500 transition">
                <div className="flex-shrink-0 w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center shadow-lg">
                  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    {item.icon}
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white mb-1">{item.title}</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}

          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed">
            The affiliate model scales beautifully. As your program proves successful, more affiliates join, and top performers increase their efforts. <span className="text-orange-500 font-semibold">You're building a distributed sales force</span> that grows organically based on results. Platforms like ShareASale, CJ Affiliate, and Impact make managing programs straightforward, even for smaller businesses.
          </p>

        </div>
      </section>

      {/* Franchisee Marketing: Supporting Local Success Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            Franchisee Marketing: Supporting Local Success
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* Subheading */}
              <h3 className="text-3xl font-bold text-white mb-6">
                Corporate Meets Local
              </h3>

              {/* First Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Franchisee marketing presents unique challenges—balancing corporate brand consistency with local market needs. National campaigns must support individual franchise locations while maintaining unified messaging and brand standards across all locations.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Successful franchise marketing operates on two levels simultaneously. Corporate provides overarching strategy, brand assets, and national campaigns, while individual franchisees execute localized tactics that resonate with their specific communities and competitive environments.
              </p>

            </div>

            {/* Right Side - Store Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_57.png" 
                  alt="Franchisee Store" 
                  className="w-full h-[350px] object-cover"
                />
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Franchisee Marketing Components Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-6xl mx-auto">
          
          {/* Timeline with 4 Components */}
          <div className="relative">
            
            {/* Vertical Line */}
            <div className="absolute left-1/2 top-0 bottom-0 w-px bg-orange-500 transform -translate-x-1/2"></div>

            {/* Component 1 - Corporate Brand Campaigns */}
            <div className="relative mb-16">
              <div className="grid grid-cols-2 gap-12 items-center">
                
                {/* Left Side - Title and Description */}
                <div className="text-right">
                  <h3 className="text-2xl font-bold text-white mb-4">Corporate Brand Campaigns</h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    National advertising, brand positioning, and centralized digital assets that maintain consistency
                  </p>
                </div>

                {/* Center - Number Circle */}
                <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 top-1/2">
                  <div className="w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-xl">1</span>
                  </div>
                </div>

                {/* Right Side - Empty for alignment */}
                <div></div>

              </div>
            </div>

            {/* Component 2 - Co-Op Marketing Programs */}
            <div className="relative mb-16">
              <div className="grid grid-cols-2 gap-12 items-center">
                
                {/* Left Side - Empty for alignment */}
                <div></div>

                {/* Center - Number Circle */}
                <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 top-1/2">
                  <div className="w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-xl">2</span>
                  </div>
                </div>

                {/* Right Side - Title and Description */}
                <div className="text-left">
                  <h3 className="text-2xl font-bold text-white mb-4">Co-Op Marketing Programs</h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Shared funding models where corporate and franchisees contribute to regional campaigns
                  </p>
                </div>

              </div>
            </div>

            {/* Component 3 - Local Store Marketing */}
            <div className="relative mb-16">
              <div className="grid grid-cols-2 gap-12 items-center">
                
                {/* Left Side - Title and Description */}
                <div className="text-right">
                  <h3 className="text-2xl font-bold text-white mb-4">Local Store Marketing</h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Community sponsorships, local events, and neighborhood-specific promotions
                  </p>
                </div>

                {/* Center - Number Circle */}
                <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 top-1/2">
                  <div className="w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-xl">3</span>
                  </div>
                </div>

                {/* Right Side - Empty for alignment */}
                <div></div>

              </div>
            </div>

            {/* Component 4 - Digital Listings Management */}
            <div className="relative mb-16">
              <div className="grid grid-cols-2 gap-12 items-center">
                
                {/* Left Side - Empty for alignment */}
                <div></div>

                {/* Center - Number Circle */}
                <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 top-1/2">
                  <div className="w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-xl">4</span>
                  </div>
                </div>

                {/* Right Side - Title and Description */}
                <div className="text-left">
                  <h3 className="text-2xl font-bold text-white mb-4">Digital Listings Management</h3>
                  <p className="text-gray-300 text-base leading-relaxed">
                    Ensuring accurate information across Google, Yelp, and directories for every location
                  </p>
                </div>

              </div>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mt-12">
            Technology platforms now enable franchise marketing at scale. Centralized systems distribute approved content, manage local social media, and provide franchisees with customizable templates that maintain brand standards while allowing local personalization. This "glocal" approach—global strategy with local execution—drives results for both corporate and individual franchise owners.
          </p>

        </div>
      </section>

      {/* Mobile Marketing: Reaching On-The-Go Consumers Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/70">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Mobile Marketing: Reaching On-The-Go Consumers
          </h2>

          {/* First Paragraph */}
          <p className="text-black text-lg leading-relaxed mb-6">
            Mobile marketing encompasses SMS campaigns, app notifications, and mobile-first campaign strategies. With over 85% of Americans owning smartphones and checking them 96 times per day, mobile represents an always-accessible channel for reaching your audience wherever they are.
          </p>

          {/* Second Paragraph */}
          <p className="text-black text-lg leading-relaxed mb-12">
            Mobile's power comes from immediacy and location awareness. SMS messages have 98% open rates—compared to 20% for email—and are typically read within three minutes of receipt. Push notifications from apps can deliver personalized messages based on user behavior, preferences, and even physical location.
          </p>

          {/* Three Strategy Cards */}
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8 mb-8 sm:mb-12">
            
            {/* Card 1 - SMS Marketing */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black mb-4">SMS Marketing</h3>
              <p className="text-black text-base leading-relaxed">
                Direct text message campaigns for promotions, updates, and time-sensitive offers with incredibly high engagement rates
              </p>
            </div>

            {/* Card 2 - Push Notifications */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black mb-4">Push Notifications</h3>
              <p className="text-black text-base leading-relaxed">
                App-based alerts that re-engage users, drive actions, and deliver personalized content based on behavior
              </p>
            </div>

            {/* Card 3 - Mobile-Optimized Web */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-black mb-4">Mobile-Optimized Web</h3>
              <p className="text-black text-base leading-relaxed">
                Responsive website design ensuring seamless experiences on smaller screens with fast loading times
              </p>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <p className="text-black text-lg leading-relaxed">
            Successful mobile marketing requires permission and relevance. Users must opt-in, and messages must provide genuine value—not spam. The best mobile strategies integrate seamlessly into users' lives, offering timely information, exclusive deals, or convenient solutions exactly when needed.
          </p>

        </div>
      </section>

      {/* Video Marketing: The Engagement King Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-orange-500 mb-12">
            Video Marketing: The Engagement King
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* Subheading */}
              <h3 className="text-3xl font-bold text-white mb-6">
                Visual Storytelling
              </h3>

              {/* First Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Video marketing through YouTube, TikTok, Reels, and webinars has become essential for modern brands. Video content generates 1200% more shares than text and images combined, while viewers retain 95% of a message when watching video versus just 10% when reading text.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Different platforms serve different purposes. YouTube excels for educational content and product demonstrations. TikTok and Instagram Reels capture attention with short, entertaining clips. Webinars build authority and generate qualified leads through in-depth expertise sharing.
              </p>

            </div>

            {/* Right Side - Video Production Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_58.png" 
                  alt="Video Production Studio" 
                  className="w-full h-[300px] object-cover"
                />
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Video Marketing Types Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-6xl mx-auto">
          
          {/* Four Video Type Cards */}
          <div className="space-y-8 mb-12">
            
            {/* Card 1 - YouTube Strategy */}
            <div className="flex items-start gap-6">
              {/* Icon Circle */}
              <div className="flex-shrink-0 w-20 h-20 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">YouTube Strategy</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Long-form content, tutorials, product reviews, and thought leadership videos that rank in both YouTube and Google search
                </p>
              </div>
            </div>

            {/* Card 2 - Short-Form Social Video */}
            <div className="flex items-start gap-6">
              {/* Icon Circle */}
              <div className="flex-shrink-0 w-20 h-20 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Short-Form Social Video</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  TikTok and Instagram Reels capturing attention with 15-60 second entertaining, authentic content optimized for mobile consumption
                </p>
              </div>
            </div>

            {/* Card 3 - Webinars & Live Streams */}
            <div className="flex items-start gap-6">
              {/* Icon Circle */}
              <div className="flex-shrink-0 w-20 h-20 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                </svg>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Webinars & Live Streams</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Interactive educational sessions that demonstrate expertise, engage audiences in real-time, and generate high-quality leads
                </p>
              </div>
            </div>

            {/* Card 4 - Video Ads */}
            <div className="flex items-start gap-6">
              {/* Icon Circle */}
              <div className="flex-shrink-0 w-20 h-20 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Video Ads</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Pre-roll, in-stream, and bumper ads on platforms like YouTube delivering targeted messages to specific audience segments
                </p>
              </div>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed">
            The barrier to entry for video has never been lower. Smartphones now shoot professional-quality footage, and editing apps make production accessible. While polished production has its place, audiences increasingly value authenticity over perfection—making video marketing feasible for businesses of all sizes.
          </p>

        </div>
      </section>

      {/* Podcast Marketing: Audio Influence Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-orange-500 mb-12">
            Podcast Marketing: Audio Influence
          </h2>

          {/* First Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-6">
            Podcast marketing includes sponsorships, branded shows, and guest appearances on established programs. With over 460 million podcast listeners worldwide and growing, audio content offers an intimate way to reach engaged audiences during commutes, workouts, and daily routines.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed mb-12">
            Podcasts create unique engagement. Listeners typically consume entire episodes, providing 30-60 minutes of focused attention—a marketer's dream in today's fragmented media landscape. The host relationship builds trust that transfers to sponsors, making podcast advertising particularly effective for brand building and direct response.
          </p>

          {/* Three Strategy Boxes - Staggered Layout */}
          <div className="space-y-8 mb-12">
            
            {/* Box 1 - Podcast Sponsorships (Top Left) */}
            <div className="max-w-2xl">
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-4 text-center">Podcast Sponsorships</h3>
                <p className="text-gray-300 text-base leading-relaxed text-center">
                  Purchase ad spots on existing shows that align with your target audience. Host-read ads perform best, leveraging the trust between host and listener. Pre-roll, mid-roll, and post-roll options available at varying price points.
                </p>
              </div>
            </div>

            {/* Box 2 - Branded Podcasts (Middle Right) */}
            <div className="max-w-2xl ml-auto">
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-4 text-center">Branded Podcasts</h3>
                <p className="text-gray-300 text-base leading-relaxed text-center">
                  Create your own show to build authority and audience. Requires commitment to consistent production but builds owned media asset. Focus on providing value first, selling second—educational content works best.
                </p>
              </div>
            </div>

            {/* Box 3 - Guest Appearances (Bottom Left) */}
            <div className="max-w-2xl">
              <div className="bg-black border-2 border-orange-500 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-4 text-center">Guest Appearances</h3>
                <p className="text-gray-300 text-base leading-relaxed text-center">
                  Appear as an expert guest on relevant podcasts. Free exposure that builds credibility and drives traffic. Prepare talking points, have a clear call-to-action, and bring genuine insights that serve the host's audience.
                </p>
              </div>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-300 text-lg leading-relaxed">
            <span className="text-orange-500 font-semibold">Podcast listeners are highly engaged and loyal,</span> often feeling personal connections with hosts. This makes podcast marketing particularly effective for complex products, B2B services, or any offering that benefits from detailed explanation and trust-building over quick conversions.
          </p>

        </div>
      </section>

      {/* Choosing Your Channel Mix Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-16 text-center">
            Choosing Your Channel Mix
          </h2>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Side - Strategy Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_59.png" 
                  alt="Channel Strategy Dashboard" 
                  className="w-full h-[300px] object-cover"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="space-y-6">
              
              {/* Subheading */}
              <h3 className="text-3xl font-bold text-white mb-6">
                Strategic Selection
              </h3>

              {/* First Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                With so many channels available, the question isn't "Which channel is best?" but rather "Which combination serves my specific business goals?" The right mix depends on your audience, resources, and objectives.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Start by understanding where your target audience spends time and how they prefer to consume content. A B2B software company might prioritize LinkedIn, content marketing, and webinars, while a consumer fashion brand succeeds on Instagram, influencer partnerships, and TikTok.
              </p>

            </div>

          </div>

        </div>
      </section>
      {/* Channel Mix Strategy Steps Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-10 bg-black">
        <div className="max-w-5xl mx-auto">
          
          {/* Five Steps List */}
          <div className="space-y-8">
            
            {/* Step 1 - Audience Analysis */}
            <div className="flex items-start gap-6">
              {/* Number Circle */}
              <div className="flex-shrink-0 w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <span className="text-orange-500 font-bold text-xl">1</span>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Audience Analysis</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Research where your target customers spend time, what content they consume, and how they make purchasing decisions
                </p>
              </div>
            </div>

            {/* Step 2 - Resource Assessment */}
            <div className="flex items-start gap-6">
              {/* Number Circle */}
              <div className="flex-shrink-0 w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <span className="text-orange-500 font-bold text-xl">2</span>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Resource Assessment</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Evaluate your budget, team capabilities, and content creation capacity to determine sustainable channel commitments
                </p>
              </div>
            </div>

            {/* Step 3 - Goal Alignment */}
            <div className="flex items-start gap-6">
              {/* Number Circle */}
              <div className="flex-shrink-0 w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <span className="text-orange-500 font-bold text-xl">3</span>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Goal Alignment</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Match channels to specific objectives—awareness, consideration, conversion, or retention—based on channel strengths
                </p>
              </div>
            </div>

            {/* Step 4 - Competitive Analysis */}
            <div className="flex items-start gap-6">
              {/* Number Circle */}
              <div className="flex-shrink-0 w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <span className="text-orange-500 font-bold text-xl">4</span>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Competitive Analysis</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Study where competitors are winning and losing to identify opportunities and avoid saturated spaces
                </p>
              </div>
            </div>

            {/* Step 5 - Test and Learn */}
            <div className="flex items-start gap-6">
              {/* Number Circle */}
              <div className="flex-shrink-0 w-12 h-12 bg-black border-2 border-orange-500 rounded-full flex items-center justify-center">
                <span className="text-orange-500 font-bold text-xl">5</span>
              </div>
              {/* Content */}
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-white mb-3">Test and Learn</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Start with 2-3 channels, measure results rigorously, then expand what works and cut what doesn't
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* Budget Allocation by Channel Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-orange-500/50">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Budget Allocation by Channel
          </h2>

          {/* Description Paragraph */}
          <p className="text-gray-200 text-lg leading-relaxed mb-12">
            Different channels require different investment levels and deliver returns at different timescales. Understanding the financial commitment helps you make realistic choices about channel mix.
          </p>

          {/* Bar Chart - Mobile-friendly */}
          <div className="bg-white/80 rounded-3xl p-4 sm:p-8 mb-8">
            <div className="space-y-4">
              {[
                { label: 'Social Media',      value: 2000, pct: 33 },
                { label: 'Content Marketing', value: 3500, pct: 58 },
                { label: 'Email Marketing',   value: 1500, pct: 25 },
                { label: 'SEM/PPC',           value: 5000, pct: 83 },
                { label: 'SEO',               value: 3000, pct: 50 },
                { label: 'Influencer',         value: 4500, pct: 75 },
                { label: 'Video Production',  value: 4000, pct: 66 },
              ].map((item) => (
                <div key={item.label} className="space-y-1">
                  <div className="flex justify-between items-center">
                    <span className="text-black font-semibold text-sm sm:text-base">{item.label}</span>
                    <span className="text-black font-bold text-sm sm:text-base">${item.value.toLocaleString()}</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-8 sm:h-10">
                    <div
                      className="bg-gray-800 h-full rounded-full flex items-center justify-end pr-3 transition-all duration-500"
                      style={{ width: `${item.pct}%` }}
                    >
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* X-axis labels */}
            <div className="flex justify-between mt-4 text-xs sm:text-sm text-gray-500">
              <span>$0</span>
              <span>$2,000</span>
              <span>$4,000</span>
              <span>$6,000</span>
            </div>
          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-200 text-lg leading-relaxed">
            These ranges represent typical monthly investments for small-to-medium businesses. Your actual spending should reflect your specific goals, market position, and growth stage. The key is consistency—channels need sustained investment to deliver results. Sporadic efforts across many channels underperform focused, consistent execution on fewer channels.
          </p>

        </div>
      </section>

      {/* Integration: The Multiplier Effect Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-8 text-center">
            Integration: The Multiplier Effect
          </h2>

          {/* First Paragraph */}
          <p className="text-gray-200 text-lg leading-relaxed mb-6 text-center max-w-5xl mx-auto">
            The most successful marketing programs don't treat channels as isolated silos but rather as interconnected components of a unified system. Integration multiplies effectiveness—each channel amplifies the others, creating compound returns that exceed the sum of individual efforts.
          </p>

          {/* Second Paragraph */}
          <p className="text-gray-200 text-lg leading-relaxed mb-0 text-center max-w-5xl mx-auto">
            Consider a content marketing piece: publish a blog article, promote it through email and social media, use it for SEO, create video adaptations for YouTube, pull quotes for Instagram, discuss it on your podcast, and use it in SEM landing pages. One piece of content now works across seven channels, maximizing your creation investment while maintaining consistent messaging.
          </p>

          {/* Integration Diagram - Responsive Grid (replaces broken absolute layout) */}
          <div className="relative py-8 mb-8">

            {/* Mobile & Tablet: clean grid */}
            <div className="lg:hidden">
              {/* Center hub */}
              <div className="flex justify-center mb-6">
                <div className="w-28 h-28 bg-orange-700 rounded-full flex items-center justify-center shadow-2xl">
                  <div className="text-center">
                    <svg className="w-8 h-8 text-white mx-auto mb-1" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <p className="text-white font-bold text-xs leading-tight">Integration<br/>Hub</p>
                  </div>
                </div>
              </div>
              {/* Channel cards grid */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                {[
                  { icon: <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />, label: 'Content Core', sub: 'Central message', stroke: true },
                  { icon: <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />, label: 'Email', sub: 'Direct reach', stroke: true },
                  { icon: <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />, label: 'Social', sub: 'Engagement', stroke: true },
                  { icon: <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />, label: 'SEO', sub: 'Organic discovery', stroke: true },
                  { icon: <path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />, label: 'Paid Ads', sub: 'Targeted reach', stroke: true },
                  { icon: <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></>, label: 'Video', sub: 'Visual story', stroke: true },
                ].map((ch) => (
                  <div key={ch.label} className="bg-white rounded-xl shadow-lg p-4 text-center">
                    <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        {ch.icon}
                      </svg>
                    </div>
                    <h4 className="text-black font-bold text-sm">{ch.label}</h4>
                    <p className="text-gray-500 text-xs">{ch.sub}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Desktop: original absolute positioned layout (only shown on lg+) */}
            <div className="hidden lg:block">
              <div className="max-w-3xl mx-auto relative" style={{ height: '500px' }}>
                {/* Center Hub */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
                  <div className="w-32 h-32 bg-orange-700 rounded-full flex items-center justify-center shadow-2xl">
                    <div className="text-center">
                      <svg className="w-10 h-10 text-white mx-auto mb-1" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      <p className="text-white font-bold text-xs leading-tight">Integration<br/>Hub</p>
                    </div>
                  </div>
                </div>
                {/* SVG lines */}
                <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 600 500">
                  <line x1="300" y1="250" x2="300" y2="60" stroke="#fff" strokeWidth="1.5" strokeDasharray="4,4" opacity="0.3" />
                  <line x1="300" y1="250" x2="450" y2="150" stroke="#fff" strokeWidth="1.5" strokeDasharray="4,4" opacity="0.3" />
                  <line x1="300" y1="250" x2="450" y2="350" stroke="#fff" strokeWidth="1.5" strokeDasharray="4,4" opacity="0.3" />
                  <line x1="300" y1="250" x2="300" y2="440" stroke="#fff" strokeWidth="1.5" strokeDasharray="4,4" opacity="0.3" />
                  <line x1="300" y1="250" x2="150" y2="150" stroke="#fff" strokeWidth="1.5" strokeDasharray="4,4" opacity="0.3" />
                  <line x1="300" y1="250" x2="150" y2="350" stroke="#fff" strokeWidth="1.5" strokeDasharray="4,4" opacity="0.3" />
                </svg>
                {/* Content Core - Top */}
                <div className="absolute -top-10 left-1/2 transform -translate-x-1/2">
                  <div className="bg-white rounded-xl shadow-xl p-5 w-36 text-center">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                      <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                    </div>
                    <h4 className="text-black font-bold text-sm mb-1">Content<br />Core</h4>
                    <p className="text-gray-600 text-xs">Central<br />message</p>
                  </div>
                </div>
                {/* Email + Social - Right */}
                <div className="absolute top-[18%] right-[9%]">
                  <div className="space-y-4">
                    <div className="bg-white rounded-xl shadow-xl p-5 w-36 text-center">
                      <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                      </div>
                      <h4 className="text-black font-bold text-sm mb-1">Email</h4>
                      <p className="text-gray-600 text-xs">Direct reach</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-xl p-5 w-36 text-center">
                      <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                      </div>
                      <h4 className="text-black font-bold text-sm mb-1">Social</h4>
                      <p className="text-gray-600 text-xs">Engagement</p>
                    </div>
                  </div>
                </div>
                {/* Video - Bottom */}
                <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2">
                  <div className="bg-white rounded-xl shadow-xl p-5 w-36 text-center">
                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>
                    <h4 className="text-black font-bold text-sm mb-1">Video</h4>
                    <p className="text-gray-600 text-xs">Visual story</p>
                  </div>
                </div>
                {/* SEO + Paid Ads - Left */}
                <div className="absolute top-[17%] left-[10%]">
                  <div className="space-y-4">
                    <div className="bg-white rounded-xl shadow-xl p-5 w-36 text-center">
                      <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                      </div>
                      <h4 className="text-black font-bold text-sm mb-1">SEO</h4>
                      <p className="text-gray-600 text-xs">Organic<br/>discovery</p>
                    </div>
                    <div className="bg-white rounded-xl shadow-xl p-5 w-36 text-center">
                      <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mx-auto mb-2">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                      </div>
                      <h4 className="text-black font-bold text-sm mb-1">Paid Ads</h4>
                      <p className="text-gray-600 text-xs">Targeted reach</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* Bottom Stat Cards */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            
            {/* Stat 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-orange-500 text-center">
              <div className="text-5xl font-bold text-orange-600 mb-2">3.2x</div>
              <h4 className="text-black font-bold text-lg mb-2">Better ROI</h4>
              <p className="text-gray-600 text-sm">Integrated campaigns vs single-channel</p>
            </div>

            {/* Stat 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-orange-500 text-center">
              <div className="text-5xl font-bold text-orange-600 mb-2">7</div>
              <h4 className="text-black font-bold text-lg mb-2">Touchpoints</h4>
              <p className="text-gray-600 text-sm">Before average customer converts</p>
            </div>

            {/* Stat 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-xl border-2 border-orange-500 text-center">
              <div className="text-5xl font-bold text-orange-600 mb-2">65%</div>
              <h4 className="text-black font-bold text-lg mb-2">More Effective</h4>
              <p className="text-gray-600 text-sm">Cross-channel messaging recall</p>
            </div>

          </div>

          {/* Bottom Paragraph */}
          <p className="text-gray-200 text-lg leading-relaxed text-center max-w-5xl mx-auto">
            Integration also means consistent messaging across touchpoints. Customers rarely convert on first exposure—they need multiple interactions across various channels before making decisions. Coordinated multi-channel campaigns create the repetition and reinforcement necessary for brand recall and conversion.
          </p>

        </div>
      </section>

      {/* Measuring Success Across Channels Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20 bg-orange-500/60">
        <div className="max-w-7xl mx-auto">
          
          {/* Dark Content Card */}
          <div className="bg-white/20 rounded-3xl p-12 lg:p-16">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
              Measuring Success Across Channels
            </h2>

            <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 mb-8 sm:mb-12">
              
              {/* Left Side - Content */}
              <div className="space-y-6">
                
                {/* First Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                  Different channels require different metrics for success evaluation. Understanding appropriate KPIs for each channel ensures you're optimizing for the right outcomes and making informed budget allocation decisions.
                </p>

                {/* Second Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                  Awareness channels like social media and content marketing focus on reach, impressions, and engagement. Conversion channels like SEM and email prioritize click-through rates, conversion rates, and ROI. Mid-funnel channels balance both awareness and conversion metrics.
                </p>

                {/* Third Paragraph */}
                <p className="text-gray-300 text-lg leading-relaxed">
                  The mistake many marketers make is applying identical metrics across all channels. YouTube shouldn't be judged solely on direct conversions if its primary role is education and awareness. Similarly, email shouldn't be measured just on opens if its goal is driving purchases.
                </p>

              </div>

              {/* Right Side - Analytics Dashboard Image */}
              <div className="relative">
                <div className="relative rounded-3xl overflow-hidden">
                  <img 
                    src="/Assests/home_page_65.png" 
                    alt="Analytics Dashboard" 
                    className="w-full h-[450px] object-cover"
                  />
                </div>
              </div>

            </div>

            {/* Three Metrics Stats */}
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              
              {/* Stat 1 - Average ROI Multiple */}
              <div className="text-center">
                <div className="text-6xl font-bold text-black/80 mb-4">3.2</div>
                <h3 className="text-xl font-bold text-white mb-3">Average ROI Multiple</h3>
                <p className="text-gray-200 text-base">
                  For integrated campaigns vs. single-channel efforts
                </p>
              </div>

              {/* Stat 2 - Touchpoints Needed */}
              <div className="text-center">
                <div className="text-6xl font-bold text-black/80 mb-4">7</div>
                <h3 className="text-xl font-bold text-white mb-3">Touchpoints Needed</h3>
                <p className="text-gray-200 text-base">
                  Before average customer converts
                </p>
              </div>

              {/* Stat 3 - Attribution Accuracy */}
              <div className="text-center">
                <div className="text-6xl font-bold text-black/80 mb-4">68%</div>
                <h3 className="text-xl font-bold text-white mb-3">Attribution Accuracy</h3>
                <p className="text-gray-200 text-base">
                  Improvement with proper tracking setup
                </p>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Common Channel Selection Mistakes Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Dark Content Card */}
          <div className="bg-orange-500/70 rounded-3xl p-12 lg:p-16">
            
            {/* Main Heading */}
            <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
              Common Channel Selection Mistakes
            </h2>

            {/* Four Mistake Cards - 2x2 Grid */}
            <div className="grid md:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
              
              {/* Mistake 1 - Chasing Shiny Objects */}
              <div className="bg-black border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-4">Chasing Shiny Objects</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Jumping to every new platform or trend without strategic reasoning. New isn't always better—TikTok might be hot, but if your audience is 55+ executives, LinkedIn matters more. Evaluate new channels against your specific audience and goals rather than following trends blindly.
                </p>
              </div>

              {/* Mistake 2 - Spreading Too Thin */}
              <div className="bg-black border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-4">Spreading Too Thin</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Attempting to be everywhere simultaneously with insufficient resources. Three channels done excellently outperform ten channels done poorly. Focus creates expertise, consistency, and better results. Start narrow, master those channels, then expand strategically.
                </p>
              </div>

              {/* Mistake 3 - Expecting Instant Results */}
              <div className="bg-black border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-4">Expecting Instant Results</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Abandoning channels before they have time to work. SEO takes 3-6 months. Content marketing compounds over time. Social media requires consistent presence. Give channels adequate runway before judging success. The exception is paid advertising, which can validate quickly.
                </p>
              </div>

              {/* Mistake 4 - Ignoring Audience Preferences */}
              <div className="bg-black border-2 border-gray-200 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-white mb-4">Ignoring Audience Preferences</h3>
                <p className="text-gray-300 text-base leading-relaxed">
                  Choosing channels based on personal preference rather than data. Your audience's behavior matters more than what you personally enjoy. Research where they spend time, how they consume content, and what influences their decisions—then meet them there.
                </p>
              </div>

            </div>

            {/* Bottom Paragraph with Highlight */}
            <p className="text-white text-lg leading-relaxed">
              The most common mistake is treating channel selection as permanent.Markets evolve, audiences shift, and new platforms emerge. Successful marketers continuously reassess their channel mix, testing new opportunities while maintaining core channels that consistently deliver results.
            </p>

          </div>

        </div>
      </section>

      {/* Future-Proofing Your Channel Strategy Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-20">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-8 sm:mb-12">
            Future-Proofing Your Channel Strategy
          </h2>

          <div className="grid lg:grid-cols-2 gap-6 sm:gap-12 mb-8 sm:mb-12">
            
            {/* Left Side - Content */}
            <div className="space-y-6">
              
              {/* Subheading */}
              <h3 className="text-3xl font-bold text-white mb-6">
                Adapting to Change
              </h3>

              {/* First Paragraph */}
              <p className="text-gray-200 text-lg leading-relaxed">
                The marketing landscape shifts constantly—new platforms launch, algorithms change, consumer preferences evolve, and technology disrupts established channels. Building a resilient channel strategy means balancing current effectiveness with future adaptability.
              </p>

              {/* Second Paragraph */}
              <p className="text-gray-200 text-lg leading-relaxed">
                Diversification provides protection against channel dependency. Businesses that relied solely on Facebook organic reach suffered when algorithms changed. Those dependent on Google rankings faced disruption from AI-powered search. Spreading efforts across owned, earned, and paid channels creates stability.
              </p>

            </div>

            {/* Right Side - Analytics Dashboard Image */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden">
                <img 
                  src="/Assests/home_page_66.png" 
                  alt="Future Analytics Dashboard" 
                  className="w-full h-[350px] object-cover"
                />
              </div>
            </div>

          </div>

          {/* Three Strategy Arrows - Equal Size Boxes with Arrows */}
          <div className="relative mb-12">
            
            {/* Three Strategy Boxes in Row - Equal Heights */}
            <div className="grid md:grid-cols-3 gap-6">
              
              {/* Strategy 1 - Owned Media Foundation */}
              <div className="relative flex">
                <div className="bg-orange-500 rounded-lg p-6 relative flex-1">
                  {/* Arrow head on right */}
                  <div className="absolute right-0 top-1/2 transform translate-x-full -translate-y-1/2">
                    <div className="w-0 h-0 border-t-[30px] border-t-transparent border-l-[40px] border-l-orange-500 border-b-[30px] border-b-transparent"></div>
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3">Owned Media Foundation</h3>
                  <p className="text-black text-sm leading-relaxed">
                    Build email lists, websites, and content you control—channels where platform changes can't eliminate your audience overnight
                  </p>
                </div>
              </div>

              {/* Strategy 2 - Earned Media Credibility */}
              <div className="relative flex">
                <div className="bg-orange-500 rounded-lg p-6 relative flex-1">
                  {/* Arrow head on right */}
                  <div className="absolute right-0 top-1/2 transform translate-x-full -translate-y-1/2">
                    <div className="w-0 h-0 border-t-[30px] border-t-transparent border-l-[40px] border-l-orange-500 border-b-[30px] border-b-transparent"></div>
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3">Earned Media Credibility</h3>
                  <p className="text-black text-sm leading-relaxed">
                    Invest in SEO, PR, and word-of-mouth that compound over time and don't disappear if you stop spending
                  </p>
                </div>
              </div>

              {/* Strategy 3 - Paid Media Acceleration */}
              <div className="relative flex">
                <div className="bg-orange-500 rounded-lg p-6 relative flex-1">
                  {/* Arrow head on right */}
                  <h3 className="text-xl font-bold text-black mb-3">Paid Media Acceleration</h3>
                  <p className="text-black text-sm leading-relaxed">
                    Use advertising for growth and testing, but don't build your entire business on rented land controlled by platforms
                  </p>
                </div>
              </div>

            </div>

          </div>

        </div>
      </section>

      {/* Your Channel Strategy Action Plan Section */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-orange-500/70">
        <div className="max-w-7xl mx-auto">
          
          {/* Main Heading */}
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            Your Channel Strategy Action Plan
          </h2>

          {/* Description Paragraph */}
          <p className="text-gray-200 text-lg leading-relaxed mb-12">
            Now that you understand the landscape of available marketing channels, it's time to build your strategic plan. Start with your business goals, understand your audience deeply, assess your resources honestly, and commit to consistent execution on chosen channels.
          </p>

          {/* 7 Steps Grid - 3 columns top, 3 columns middle, 1 bottom */}
          <div className="space-y-8 mb-12">
            
            {/* First Row - Steps 1-3 */}
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
              
              {/* Step 1 */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-black font-mono text-lg font-bold">01</span>
                  <div className="flex-1 h-px bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">Define Clear Objectives</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Establish specific, measurable goals for the next 6-12 months
                </p>
              </div>

              {/* Step 2 */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-black font-mono text-lg font-bold">02</span>
                  <div className="flex-1 h-px bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">Audit Current Efforts</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Evaluate what's working, what's not, and where you have gaps
                </p>
              </div>

              {/* Step 3 */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-black font-mono text-lg font-bold">03</span>
                  <div className="flex-1 h-px bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">Select 2-4 Primary Channels</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Choose based on audience, resources, and goal alignment
                </p>
              </div>

            </div>

            {/* Second Row - Steps 4-6 */}
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
              
              {/* Step 4 */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-black font-mono text-lg font-bold">04</span>
                  <div className="flex-1 h-px bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">Create Integrated Calendar</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Plan content and campaigns that work across channels synergistically
                </p>
              </div>

              {/* Step 5 */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-black font-mono text-lg font-bold">05</span>
                  <div className="flex-1 h-px bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">Implement Tracking</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Set up proper analytics to measure performance accurately
                </p>
              </div>

              {/* Step 6 */}
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-black font-mono text-lg font-bold">06</span>
                  <div className="flex-1 h-px bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">Execute Consistently</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Commit to 90-day sprints with regular optimization
                </p>
              </div>

            </div>

            {/* Third Row - Step 7 (Centered) */}
            <div className="max-w-md mx-auto">
              <div className="space-y-4">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-black font-mono text-lg font-bold">07</span>
                  <div className="flex-1 h-px bg-black"></div>
                </div>
                <h3 className="text-2xl font-bold text-black">Review and Adjust</h3>
                <p className="text-gray-200 text-base leading-relaxed">
                  Quarterly assessment to refine strategy based on results
                </p>
              </div>
            </div>

          </div>

          {/* Horizontal Line */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-12"></div>

          {/* Remember Section */}
          <div className="mb-8">
            <p className="text-white text-lg leading-relaxed">
              <span className="font-bold">Remember:</span> Perfect strategy without execution means nothing. Choose channels you can commit to consistently, start with manageable scope, measure religiously, and optimize continuously. Success comes from focused, sustained effort on the right channels—not from being everywhere at once.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4">
            <button className="px-8 py-4 bg-gray-300 text-black rounded-lg font-medium text-lg hover:bg-black hover:text-white transition shadow-lg">
              Start Your Strategy
            </button>
            <button className="px-8 py-4 bg-orange-400 text-white border-2 border-white rounded-lg font-medium text-lg hover:bg-gray-300 hover:text-black transition shadow-lg">
              Download Channel Checklist
            </button>
          </div>

        </div>
      </section>

      {/* Additional CSS for arrow shape */}
      <style jsx>{`
        .clip-path-arrow {
          position: relative;
        }
        
        @media (min-width: 768px) {
          .clip-path-arrow::after {
            content: '';
            position: absolute;
            right: -20px;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-top: 40px solid transparent;
            border-bottom: 40px solid transparent;
            border-left: 20px solid #f97316;
            z-index: 10;
          }
          
          .clip-path-arrow:last-child::after {
            display: none;
          }
        }
      `}</style>

    </div>
  );
}

export default MarketingChannel;